import styled from 'styled-components/native';
import { themes } from "../../design/colors";
import Constants from 'expo-constants';

// import { iPhoneWithNotch } from '../../utils/functions';

export const StyledContainer = styled.View`
  flex: 1;
  background-color: ${themes.colors.gray0};
  padding-top: ${Constants.statusBarHeight}px;
`;
